<template>
  <v-dialog name="asd" v-model="modalComputed" persistent  max-width="780" v-if="finalizadoraComputed !== undefined">
    <v-card>

      <v-toolbar flat color="accent">
        <v-btn icon @click="modalComputed = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Planos de Pagamento {{ this.finalizadoraComputed.cc_fin }}, {{ this.finalizadoraComputed.ds_fin }}</v-toolbar-title>
      </v-toolbar>

      <v-card-text class="ma-0 pa-0">
        <v-container>
          <v-row>

            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">

              <div v-if="itens.length === 0">
                <v-alert text type="info" color="primary">N&atilde;o h&aacute; planos de pagamento para esta finalizadora</v-alert>
              </div>

              <v-simple-table class="mb-2" v-else>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Código</th>
                      <th>Prazo</th>
                      <th>Custo</th>
                      <th>%</th>
                      <th width="30"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in itens" :key="item.id_reg">
                      <td><v-chip color="primary">{{ item.cc_pla }}</v-chip></td>
                      <td>{{ item.cc_prz }}</td>
                      <td>{{ getTipo(item.cc_par_tip) }}</td>
                      <td>{{ item.pc_cus_fin }}</td>
                      <td>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                              <v-btn depressed small fab color="primary" v-on="on" v-if="item.cc_fin != 'DIN'" @click="deletar(item)">
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                          </template>
                          <span>Deletar</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card outlined>
                <v-card-text>
                  <v-form @submit="inserir()" ref="form" v-model="valid" :lazy-validation="lazy" v-if="((isDebito || isParcelavel) && itens.length == 0) || (!isDebito && isParcelavel)" v-on:submit.prevent>
                      <div class="d-flex flex-row mb-6">
                        <v-select v-model="plano.cc_prz" label="Prazo" :items="prazos" item-text="cc_prz" item-value="cc_prz" class="mr-2" :rules="validacao.cc_prz"></v-select>
                        <v-select v-model="plano.cc_par_tip" label="Custo" :items="tipos" item-text="descricao" item-value="codigo" class="mr-2" :rules="validacao.cc_par_tip"></v-select>
                        <v-text-field v-model="plano.pc_cus_fin" label="%" type="number" :rules="validacao.pc_cus_fin" class="mr-2"></v-text-field>
                      </div>
                      <v-btn depressed outlined type="submit" color="primary">INSERIR</v-btn>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {

  name: 'PontoDeVenda',

  data() {
    return {

      valid: true,
      lazy:true,
      itens:[],

      prazos:[],
      isDebito: false,
      isTEFouPOS: false,
      isParcelavel: false,

      plano: {
        cc_fil: undefined,
        cc_fin: undefined,
        cc_prz: undefined,
        cc_pla: undefined,
        pc_cus_fin: '0.00',
        cc_par_tip: 'LOJ',
      },

      validacao: {
        cc_prz: [
          (v) => !!v || 'Requerido',
        ],
        cc_par_tip: [
          (v) => !!v || 'Requerido',
        ],
        pc_cus_fin: [
          (v) => !!v || 'Requerido',
          //(v) => /^[0-9]*[.][0-9]+$/.test(v) || 'Formato inválido'
          (v) => { if(v === undefined || v < 0) {return 'Requerido'} else { return true } }
        ]
      },

      tipos: [
        {
          codigo: 'ADM',
          descricao: 'Administradora'
        },
        {
          codigo: 'LOJ',
          descricao: 'Loja'
        },
      ],

      finalizadoraTemp: undefined,
      modalTemp: undefined
    }
  },

  props: {

    finalizadora: {
      required: true
    },

    modal: {
      required: true,
      type: Boolean
    },

  },

  methods: {

    listar() {
      this.itens = []
      if(this.finalizadoraComputed !== undefined) {
        this.$store.dispatch('pesquisaPlano', {size:9999, cc_fil: this.finalizadoraComputed.cc_fil, cc_fin: this.finalizadoraComputed.cc_fin}).then(resp => {
           resp.data.content.forEach(el => {
             this.itens.push(el)
           });
         }).catch()
      }
    },

    inserir() {
      if (this.$refs.form.validate()) {

        this.plano.cc_fil = this.finalizadoraComputed.cc_fil
        this.plano.cc_fin = this.finalizadoraComputed.cc_fin
        this.plano.cc_pla = `${this.plano.cc_fin}${this.plano.cc_prz}`

        this.$store.dispatch('salvarPlano', this.plano).then(() => {
          this.listar()
          this.resetarFormulario()
        }).catch()
      }
    },

    deletar(item) {
      this.$store.dispatch('deletarPlano', item.id_reg).then(() => {
        this.listar()
      }).catch()
    },

    resetarFormulario(){
      this.$refs.form.reset()
      // eslint-disable-next-line no-debugger
      //debugger

      if(!this.isTEFouPOS) {
        this.plano.cc_par_tip = 'LOJ'
        this.plano.pc_cus_fin = 0.00
      }
      
    },

    getTipo(str){
      if(str === 'LOJ') {return "Loja"}
      else if (str === 'ADM') {return "Administradora"}
      else {return ''}
    },

    populaPrazos() {
      this.prazos = []
      if(this.finalizadoraComputed !== undefined) {
        this.$store.dispatch('pesquisaPrazo', {size:9999, cc_fil: this.finalizadoraComputed.cc_fil}).then(resp => {

            resp.data.content.forEach(el => {
             this.prazos.push(el)
            });

           // se a finalizadora for pagamento via debito, deixa nos prazos apenas o prazo de 1X
          if(this.isDebito || !this.isParcelavel) {
            let prazos = []
            this.prazos.forEach((el) => {
              if(el.cc_prz === '1X') prazos.push(el)
            });
            if(prazos.length > 0){
              this.prazos = []
              this.prazos.push(prazos[0])
            }
          }

         }).catch()
      }
    }
  },

  computed: {
    modalComputed :  {
      get: function() { 
        return this.modalTemp
      },
      set: function(value) {
        this.modalTemp = value
      }
    },
    finalizadoraComputed: {
      get: function() { 
        return this.finalizadoraTemp
      },
      set: function(value) {
        this.finalizadoraTemp = value
      }
    }
  },

  mounted: function() {
    this.listar()
    this.populaPrazos()
  },

  created: function() {

    this.modalComputed = this.modal
    this.finalizadoraComputed = this.finalizadora
    this.$emit('a')

    if( this.finalizadoraComputed != undefined) {
      
      if(this.finalizadoraComputed.cc_fin_con === 'P'){
        this.isParcelavel = true
      }

      if(['T','P'].includes(this.finalizadoraComputed.cc_fit)) {
        this.isTEFouPOS = true
      }

      // se a finalizadora for pagamento via debito, deixa nos prazos apenas o prazo de 1X
      if(this.isTEFouPOS && !this.isParcelavel) {
        this.isDebito = true
      }
    }

  }

}
</script>